import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import ProgressBar from 'react-customizable-progressbar';

const useStyles = makeStyles({
    root: {
        display: "block",
        height: 212,
    },
    loadingImage: {
        position: "absolute",
        zIndex: -1,
        top: 12,
        left: 25,
        width: 170,
        height: 170
    },
    loadingCircle: {
        position: "absolute",
        zIndex: 1
    },
    percentageNumber: {
        fontSize: 56,
        fontWeight: "bold",
        fontFamily: "CircularStd",
        color: "#4a4a4a",
        top: -78,
        position: "relative"
    },
    percentageSign: {
        fontSize: 28,
        fontWeight: "bold",
        fontFamily: "CircularStd",
        color: "#4a4a4a"
    }
});

function APRocketProgress(props: any) {
    const classes = useStyles();
    const { progress } = props;
    const [countProgress, setCountProgress] = React.useState<number>(0);

    React.useEffect(() => {
        let timer;
        if (countProgress === 0) {
            timer = setInterval(() => {
                setCountProgress((prevProgress) => (prevProgress >= 100 ? 100 : prevProgress + countProgress + 1));
            }, 1000);
        }
        return () => {
            if (countProgress === 100) {
                clearInterval(timer);
            }
        };
    }, [countProgress]);

    return (
        <div className={classes.root}>
            <ProgressBar
                className={classes.loadingCircle}
                radius={90}
                progress={progress === 0 ? countProgress : progress}
                cut={90}
                rotate={-225}
                strokeWidth={18}
                strokeColor="#2d91e9"
                trackStrokeWidth={18}
                trackStrokeColor="#eaf3ff"
                initialAnimation={true}
                transition={progress === 0 ? "1.5s ease 0.5s" : "0.1s ease 0.1s"}
                trackTransition="0s ease"
            >
                <img className={classes.loadingImage} src={require("./assets/icons/rocket-animation.gif")} alt="Loading..." />
                <div className={classes.percentageNumber}>{progress === 0 ? countProgress : progress}<span className={classes.percentageSign}>%</span></div>
            </ProgressBar>
        </div>
    );
}

export default APRocketProgress;


